import React, { useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Play, Pause } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames';
import './video-hero-image.scss';

export const VideoPlayer = ({ mobileVideoUrl, desktopVideoUrl, altText, videoClasses, mobilePosterImageUrl }) => {
  const [videoPaused, setVideoPaused] = useState(false);
  const videoRef = useRef(null);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const handlePlayPause = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const videoElement = videoRef.current;
    if (!videoElement) return;
    setVideoPaused((prev) => {
      if (prev) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
      return !prev;
    });
  };

  const videoButtonDefaultClasses = classNames(
    'sui-justify-center sui-items-center sui-bg-inactive sui-rounded-full sui-h-8 sui-w-8',
  );

  const playButtonClasses = classNames(
    'play-button',
    videoButtonDefaultClasses,
    { 'sui-flex': videoPaused, 'sui-hidden': !videoPaused }
  );

  const pauseButtonClasses = classNames(
    'pause-button',
    videoButtonDefaultClasses,
    { 'sui-flex': !videoPaused, 'sui-hidden': videoPaused }
  );

  const videoButton = (
    <button
      type="button"
      className="hero-video-button sui-absolute sui-top-4 sui-right-4 sui-flex sui-justify-end sui-items-end"
      aria-label="pause or play video"
      onClick={handlePlayPause}
    >
      <div data-testid="play-button" className={playButtonClasses}>
        <div className="play-button-hover sui-pl-1"><Play color="brand" size="small" /></div>
        <div className="play-button-no-hover sui-pl-1"><Play color="primary" size="small" /></div>
      </div>
      <div data-testid="pause-button" className={pauseButtonClasses}>
        <div className="pause-button-hover"><Pause color="brand" size="small" /></div>
        <div className="pause-button-no-hover"><Pause color="primary" size="small" /></div>
      </div>
    </button>
  );

  return (
    <div className="video-hero-image sui-relative sui-w-full sui-h-full" data-component="VideoPlayer">
      <video
        ref={videoRef}
        className={videoClasses}
        aria-label={altText}
        autoPlay
        playsInline
        poster={isMobile && mobilePosterImageUrl}
        muted
        loop
        controls=""
      >
        {desktopVideoUrl && (
          <source
            src={desktopVideoUrl}
            type="video/mp4"
            media="(min-width: 1024px)"
          />
        )}
        {mobileVideoUrl && (
          <source
            src={mobileVideoUrl}
            type="video/mp4"
          />
        )}
      </video>
      {videoButton}
    </div>
  );
};
VideoPlayer.propTypes = {
  mobileVideoUrl: PropTypes.string,
  desktopVideoUrl: PropTypes.string,
  altText: PropTypes.string,
  videoClasses: PropTypes.string,
  mobilePosterImageUrl: PropTypes.string,
};
VideoPlayer.defaultProps = {
  mobileVideoUrl: null,
  desktopVideoUrl: null,
  altText: 'Video content',
  videoClasses: '',
  mobilePosterImageUrl: null,
};
